var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-date-picker-dropdown.ts
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import {
  ElementsDatePickerDropdown,
  ElementsDatePickerDropdownContent
} from "@adornis/datetime/x-date-picker-dropdown";
import { customElement } from "lit/decorators.js";
var GeDatePickerDropdown = class extends ElementsDatePickerDropdown {
  constructor() {
    super();
    this.styles = () => ({
      "#trigger": {
        borderRadius: "4px !important",
        border: `1px solid ${this.colors.secondary} !important`,
        background: "transparent !important"
      }
    });
    this["placeholder-mode"] = "hide";
  }
};
GeDatePickerDropdown = __decorateClass([
  customElement("ge-date-picker-dropdown")
], GeDatePickerDropdown);
var GermaniumDatePickerDropdownContent = class extends ElementsDatePickerDropdownContent {
};
GermaniumDatePickerDropdownContent = __decorateClass([
  customElement("ge-date-picker-dropdown-content")
], GermaniumDatePickerDropdownContent);
export {
  GeDatePickerDropdown,
  GermaniumDatePickerDropdownContent
};
